import React, { useEffect, useState } from "react";
import { FaTimes, FaSpinner } from "react-icons/fa";

const resolveSubject = (subject, customer) => {
  if (subject?.id) {
    return subject;
  }
  if (customer) {
    return {
      id: customer.userId || customer.driverId,
      name: customer.customerName || customer.driverName || "N/A",
      mobile: customer.mobileNumber || "N/A",
    };
  }
  return null;
};

const NumberSharingInactiveModal = ({
  show,
  subject,
  customer,
  loading,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState("");
  const resolvedSubject = resolveSubject(subject, customer);

  useEffect(() => {
    if (show) {
      setReason("");
    }
  }, [show]);

  if (!show || !resolvedSubject) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Set Inactive</h3>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <FaTimes />
          </button>
        </div>
        <div className="px-6 py-4 space-y-4">
          <p className="text-sm text-gray-600">
            {resolvedSubject.name} · {resolvedSubject.mobile}
          </p>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Reason / remarks <span className="text-red-500">*</span>
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              disabled={loading}
              rows={4}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter reason for inactive status"
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 text-sm text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(reason)}
            disabled={loading || !reason.trim()}
            className="px-4 py-2 text-sm text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50 inline-flex items-center"
          >
            {loading ? (
              <>
                <FaSpinner className="animate-spin mr-2" />
                Saving...
              </>
            ) : (
              "Confirm Inactive"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NumberSharingInactiveModal;
